import classNames from 'classnames';
import React, { useCallback, useState } from "react";
import { Accordion as AccordionB, Button, Card } from 'react-bootstrap';

const Accordion = ({ defaultActiveIndex, collapsibles, className }) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);

  const handleClick = useCallback((index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  }, [activeIndex]);

  return (
    <AccordionB activeKey={activeIndex} className={classNames(className)}>
      {
        collapsibles.map((collapsible, index) => (
          <Card key={collapsible.header}>
            <Card.Header>
              <AccordionB.Toggle
                as={Button}
                eventKey={index + 1}
                variant="tertiary"
                onClick={() => handleClick(index + 1)}
                className={classNames({ active: activeIndex === index + 1 })}>
                <div className="headerText">
                  {collapsible.header}
                </div>
                <div className="icon">
                  {
                    activeIndex === index + 1
                      ? <i className="fal fa-minus"></i>
                      : <i className="fal fa-plus"></i>
                  }
                </div>
              </AccordionB.Toggle>
            </Card.Header>

            <AccordionB.Collapse eventKey={index + 1} >
              <Card.Body>
                <Card.Title as='h6'>{collapsible.title}</Card.Title>
                <div className='card-text'>
                  {collapsible.content}
                </div>
              </Card.Body>
            </AccordionB.Collapse>
          </Card>
        ))
      }
    </AccordionB >
  );

};

export default React.memo(Accordion);
